<template>
  <div class="record_content" ref="record">
    <el-tabs
      v-model="editableTabsValue"
      type="card"
      closable
      @edit="handleTabsEdit"
      @tab-click="tabClick"
    >
      <el-tab-pane
        :key="index"
        v-for="(item, index) in editableTabs"
        :label="item.title"
        :name="item.name"
      >
        <!-- {{ item.content }} -->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getRecrdData, setRecrdData } from "@/common/oauth";
export default {
  name: "record",
  data() {
    return {
      editableTabsValue: "1", //默认显示的tab
      editableTabs: [], //历史记录
      tabIndex: 1,
    };
  },
  watch: {
    $route: function (to) {
      //监听路由的变化，动态生成editableTabs
      let flag = true; //判断是否需要新增页面
      let recrdData = JSON.parse(getRecrdData() || []);
      recrdData.forEach((item) => {
        if (item.content == to.path) {
          flag = false;
          this.editableTabsValue = item.name;
        }
      });
      if (flag) {
        let name = Number(this.editableTabs.slice(-1)[0].name);
        this.editableTabsValue = JSON.stringify(name + 1);
        this.editableTabs.push({
          title: this.$route.meta.title,
          name: this.editableTabsValue,
          content: this.$route.path,
        });
        setRecrdData(JSON.stringify(this.editableTabs));
      }
    },
  },
  created() {
    this.initRecrd();
  },
  mounted() {},
  methods: {
    handleTabsEdit(targetName) {
      // 获取下标
      // 点击的下标
      let clickIndex = this.editableTabs
        .map((item) => item.name)
        .indexOf(targetName);
      // 当前选中的下标
      let Index = this.editableTabs
        .map((item) => item.name)
        .indexOf(this.editableTabsValue);
      let len = this.editableTabs.length - 1;
      if (len != 0) {
        this.editableTabs.splice(clickIndex, 1);
        setRecrdData(JSON.stringify(this.editableTabs));
        if (clickIndex > Index) return;
        // 当点击到最后一个
        if (clickIndex == len) {
          this.$router.push(this.editableTabs[clickIndex - 1].content);
        } else {
          this.$router.push(this.editableTabs[clickIndex].content);
        }
      } else {
        return false;
      }
    },
    // 选中
    tabClick(e) {
      let path = this.editableTabs[e.index].content;
      if (path == this.$route.path) {
        return;
      } else {
        this.$router.push(path);
      }
    },
    initRecrd() {
      let recrdData = JSON.parse(getRecrdData()) || [];
      if (recrdData.length > 0) {
        //有记录
        let flag = false; //判断是否需要新增页面
        console.log('recrdData',recrdData)
        recrdData.forEach((item) => {
          if (item.content == this.$route.path) {
            this.editableTabsValue = item.name;
          }
          if (item.name == this.editableTabsValue) {
            flag = true;
          }
        });
        if (flag) {
          this.editableTabs = recrdData;
        }
      } else {
        //无记录
        this.editableTabsValue = "1";
        this.editableTabs.push({
          title: this.$route.meta.title,
          name: this.editableTabsValue,
          content: this.$route.path,
        });
        setRecrdData(JSON.stringify(this.editableTabs));
      }
    },
  },
};
</script>

<style scoped>
.record_content {
  text-align: left;
  width: 600px;
  height: 50px;
  margin-left: 10px;
}

/deep/ .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
}

/deep/ .el-tabs--card > .el-tabs__header {
  border: none;
}

/deep/ .el-tabs__item {
  font-size: 12px;
  padding: 0 10px;
  height: 50px;
  line-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/record.vue